import React, { memo } from 'react';
import styles from './ParticlesBackground.module.css';

// Memoise the particles component to prevent unnecessary re-renders
const ParticlesBackground = memo(() => {
    // Pre-calculate particle styles to avoid computing during render
    const particlesData = Array(15).fill(0).map((_, index) => ({
      key: index,
      style: {
        left: `${Math.random() * 100}%`,
        top: `${Math.random() * 100}%`,
        animationDuration: `${Math.random() * 20 + 15}s`,
        animationDelay: `${Math.random() * 5}s`,
        width: `${Math.random() * 10 + 5}px`,
        height: `${Math.random() * 10 + 5}px`,
        opacity: Math.random() * 0.5 + 0.2
      }
    }));
  
    return (
      <div className={styles.particles}>
        {particlesData.map(particle => (
          <div 
            key={particle.key} 
            className={styles.particle}
            style={particle.style}
          />
        ))}
      </div>
    );
  });
  
  ParticlesBackground.displayName = 'ParticlesBackground';

  export default ParticlesBackground;